import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function ForexBrokerageLicenseMwali (){

    return (
        <main className='main'>

            <IntroSection
                title="Forex & Brokerage License – Mwali (Comoros)"
                subtitle="Launch Your Brokerage with MISA Licensing"
                description =
                    "
                        Mwali (<b>Mohéli, Comoros</b>), under the <b>Mwali International Services Authority (MISA)</b>, is one of the most respected offshore jurisdictions for <b>Forex & Brokerage Licenses</b>. With <b>global recognition</b>, <b>moderate requirements</b>, and <b>faster approvals</b> than Tier-1 regulators, Mwali is a preferred option for <b>forex brokers</b>, <b>CFD providers</b>, and <b>investment dealers</b> seeking international operations.
                    "
                badges={
                    [
                        "Forex Brokerage License",
                        "CFD & Derivatives",
                        "Investment Dealer License",
                        "Prop Trading"
                    ]
                }
                buttonText="Request a Mwali Brokerage License Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/forex-brokerage-license-mwali-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Mwali?'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "Global Recognition",
                                            text: "More respected internationally compared to newer offshore regulators such as Anjouan or Western Sahara, offering stronger credibility for brokers."
                                        },
                                        {
                                            title: "Regulated by MISA",
                                            text: "Supervised by the Mwali International Services Authority (MISA), a credible offshore regulator operating under FATF-guided compliance standards."
                                        },
                                        {
                                            title: "Multi-Model Flexibility",
                                            text: "Supports STP, ECN, Market Maker brokerage models, as well as modern Prop Firm structures and hybrid operational setups."
                                        },
                                        {
                                            title: "Better PSP and Liquidity Access",
                                            text: "Mwali licensees enjoy smoother onboarding with payment processors, banks, and top-tier liquidity providers compared to many offshore jurisdictions."
                                        },
                                        {
                                            title: "Affordable and Faster",
                                            text: "More cost-effective and significantly faster to obtain than Tier-1 EU licenses such as CySEC or FCA, making it ideal for global brokerage operations."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="What the License Covers"
                        subtitle='A Mwali Brokerage License allows you to:'
                        item={
                            [
                                {
                                    title: "Forex Brokerage",
                                    text: "Operate a Forex Brokerage using STP, ECN, or Market Maker models."
                                },
                                {
                                    title: "CFD & Derivatives Trading",
                                    text: "Offer trading in commodities, indices, crypto CFDs, and stocks."
                                },
                                {
                                    title: "Investment Dealer Services",
                                    text: "Provide advisory services and portfolio management for clients."
                                },
                                {
                                    title: "Prop Trading Firms",
                                    text: "Run funded trader programs and proprietary trading operations."
                                },
                                {
                                    title: "Hybrid Forex + Crypto Brokerage",
                                    text: "Combine Forex and cryptocurrency brokerage services under one license."
                                }
                            ]

                        }
                    />

                    <InfoBlocks
                        title="Capital Requirements"
                        blocks={[
                            {
                                title: "Class A — Full Forex & Brokerage License",
                                items:
                                    [
                                        { text: "Flexible requirements compared to EU regulators." },
                                        { text: "Typically USD 50,000–150,000+ (depending on brokerage model & license scope)." },
                                        { text: "Final requirement is determined by MISA during application review." }
                                    ]

                            },
                        ]}
                    />

                    <FeatureCards
                        title='Benefits of a Mwali Brokerage License'
                        features={
                            [
                                {
                                    title: "International Credibility",
                                    text: "Accepted by PSPs and liquidity providers, enhancing broker legitimacy."
                                },
                                {
                                    title: "Scalable Models",
                                    text: "Start as STP or ECN and expand to Market Maker or Prop Trading models later."
                                },
                                {
                                    title: "Banking & Payment Access",
                                    text: "Easier onboarding with banks and payment processors than unregulated jurisdictions."
                                },
                                {
                                    title: "Compliance-Oriented",
                                    text: "FATF-aligned AML/KYC frameworks ensure robust regulatory compliance."
                                },
                                {
                                    title: "Faster Setup",
                                    text: "Licensing process can be completed in 2–3 weeks versus 6–12 months in EU/UK jurisdictions."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title=' Licensing Process'
                        services={
                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Decide on STP, ECN, Market Maker, or Prop Trading model."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Establish an International Business Company (IBC) under Mwali jurisdiction."
                                },
                                {
                                    title: "Compliance Preparation",
                                    text: "Prepare AML/KYC policies, risk management frameworks, and a business plan."
                                },
                                {
                                    title: "Application Filing",
                                    text: "Offshore Advisory submits the license application to MISA."
                                },
                                {
                                    title: "Approval & Activation",
                                    text: "License is issued; begin PSP, banking, and liquidity provider integration."
                                }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "2-3 weeks",
                                background: "#E-FF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Class A License",
                                description: "from USD 18,000+",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requiremen",
                                description: "USD 50k–150k (depending on scope)",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Renewals",
                                description: "moderate annual fees compared to Seychelles or Belize",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    title: "Licensed CRA-Agent Expertise",
                                    text: "We are officially authorized and experienced with CRA licensing procedures, ensuring smooth navigation through regulatory requirements."
                                },
                                {
                                    title: "End-to-End Brokerage Setup",
                                    text: "Full service including company formation, license application, compliance documentation, and MT4/MT5 platform integration."
                                },
                                {
                                    title: "Banking & PSP Introductions",
                                    text: "Access to reliable fiat and crypto payment processors, banking partners, and merchant service providers."
                                },
                                {
                                    title: "Liquidity Provider Access",
                                    text: "Direct connections to reputable forex and CFD liquidity providers for ECN, STP, and Market Maker models."
                                },
                                {
                                    title: "Transparent Pricing & Timelines",
                                    text: "Clear cost structure and predictable licensing schedules with no hidden fees."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                             Ready to launch your brokerage?
                             "
                         description=
                             "
                             Mwali offers a <b>credible, flexible, and globally recognized Forex & Brokerage License</b> with <b>faster approvals</b> than EU regulators.
                             "
                         buttonText='Book a Mwali Brokerage License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How recognized is a Mwali brokerage license?",
        content: [
            { type: "answer", text: "Highly recognized offshore license, trusted by PSPs, liquidity providers, and industry players." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "2–3 weeks, much faster than EU regulators." },
        ],
    },
    {
        question: "Is there a fixed capital requirement?",
        content: [
            { type: "answer", text: "Mwali has flexible capital, typically USD 50k–150k depending on the model." },
        ],
    },
    {
        question: "Can I operate a prop trading firm under this license?",
        content: [
            { type: "answer", text: "Yes — prop trading structures are supported." },
        ],
    },
    {
        question: "Can I combine forex with crypto trading?",
        content: [
            { type: "answer", text: "Yes — Mwali supports hybrid brokerage + crypto models." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We licensed our forex brokerage in Mwali with Offshore Advisory. PSP acceptance was strong and the process clear.",
            author: "Daniel H.",
            role: "Broker CEO"
        },
        {
            quote: "Mwali licensing gave us credibility with liquidity providers. Offshore Advisory handled MT5 integration professionally.",
            author: "Sarah L.",
            role: "FX Entrepreneur"
        }
    ]
;